<template>
    <div>

        <!-- Titlebar
        ================================================== -->
        <!-- <div id="titlebar" class="gradient"> -->
        <!-- <div id="titlebar" class="gradient signup_mrgn">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">About our Job Posting Site</h2>
                    </div>
                </div>
            </div>
        </div> -->


    <!-- Page Content
        ================================================== -->
        <div v-bind:style="{backgroundImage: 'url('+ ( about_us[0].image ? about_us[0].image: webUrl+'assets/images/about-us-image.webp' )+ ')'} " class="about_bg_image bg_img_top">
             <div class="full_gragient">
                <div id="titlebar" class="gradient signup_mrgn about_headings">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="text-center common_top_banner_of_web_heading">{{ $t('about.title') }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
        </div>
        <div class="container">
                <div class="row">
                    <div class="col-xl-6 col-md-6 about_sub_img_web">
                        <img :src="webUrl+'assets/images/about-us.webp'" alt="EL Connect team — Singapore part-time and gig job platform" />
                    </div>
                    <div class="col-xl-6 col-md-6 about_sub_para_web">
                        <div>
                            <h2 class="about_sub_para_web_heading">{{ $t('about.empowering_work') }}<br>{{ $t('about.through_technology') }}</h2>
                            <p class="about_sub_para_web_paragraph mb-0">{{ $t('about.intro') }}</p>
                        </div>
                    </div>
                </div>
                <div class="row padding_top_eighty_about padding_bottom_eighty_about">
                    <div class="col-xl-4 col-md-4 spacing-right">
                        <p class="color_rating_web">{{ homepage_statistics.google_rating }}</p>
                        <p class="text_rating_web">{{ $t('about.google_ratings') }}</p>
                        <p class="para_rating_web">{{ $t('about.google_ratings_desc') }}</p>
                    </div>
                    <div class="col-xl-4 col-md-4 spacing-right">
                        <p class="color_rating_web">{{ homepage_statistics.total_deployed | stats_format }}</p>
                        <p class="text_rating_web">{{ $t('about.successful_deployment') }}</p>
                        <p class="para_rating_web">{{ $t('about.successful_deployment_desc') }}</p>
                    </div>
                    <div class="col-xl-4 col-md-4">
                        <p class="color_rating_web">{{ homepage_statistics.active_user_count | stats_format }}</p>
                        <p class="text_rating_web">{{ $t('about.active_users') }}</p>
                        <p class="para_rating_web mb-0 desktop_margin_bottom_zero">{{ $t('about.active_users_desc') }}</p>
                    </div>
                </div>

                <div class="row">
                    <div v-if="about_us.length > 0" class="col-xl-12 col-md-12 common_block last_child_p  mobile_tab_max_width_flex about_content">
                        <div v-if="about_us[0].description" class="">
                            <p v-html="about_us[0].description"></p>
                        </div>
                        <div v-else class="no_data_about  mobile_tab_max_width_flex">
                            <h3>{{ $t('about.no_data') }}</h3>
                        </div>
                    </div>
                <!-- <div class="col-xl-6 col-md-6 iframe_about mobile_tab_max_width_flex">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d249.29611652326852!2d103.85267313372445!3d1.3334428538541812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da176451bf8fe3%3A0xd9f3227da2258e46!2sThe%20Actuary!5e0!3m2!1sen!2sin!4v1691557100744!5m2!1sen!2sin"  height="350" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div> -->
                </div>
        </div>
       <!--  <div class="video common_padding_bottom_50 about_ifame_video" id="exploration">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                            <div class="exploration" v-for="(exploration, h) in video" :key="h">
                            <iframe :src = "exploration.link"
                                    class="fade-in"
                                    title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            <div class="desc fade-down">
                                <p>{{ exploration.description }}</p>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
 -->
        <!-- <div class="container" v-else>
            <div class="row">
                <div class="col-xl-5 offset-xl-3">
                    <div class="col-xl-5 offset-xl-3">
                        <h3>{{ $t('about.no_data') }}</h3>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Spacer -->
        <div class="margin-top-70 mobile_margin_top_35"></div>
        <!-- Spacer / End-->
    </div>
</template>

<style scoped>
  @import '../../assets/css/style.css';
  @import '../../assets/css/icons.css';

  /* Color css  */

  @import '../../assets/css/colors/blue.css';

</style>
<script>
    import { POST_API } from "../../store/actions.type"
    import { getMetaInfo } from '@/seo.config';

    export default {
        metaInfo() { return getMetaInfo('/about-us'); },
        data() {
            return {
                about_us:[],
                homepage_statistics: {},
                showDismissibleAlert:false,
                error_message:'',
                display:true,
                link_error:'',
                webUrl: process.env.VUE_APP_URL,
                video: null,
            }
        },
        filters: {
            stats_format: function(value) {
                if (!value) return '0'
                value = value.toString()
                if(value >= 1000 && value < 1000000){
                    return value < 10000
                        ? (value/1000).toFixed(1) + 'k+'
                        : Math.round(value/1000) + 'k+';
                }
                else if(value >= 1000000){
                    return (value/1000000).toFixed(1) + 'M+';
                }
                else{
                    return value;
                }
            }
        },
        methods:{
            getHomepageData() {
                return this.$store
                    .dispatch(POST_API, {
                    data: {},
                    api: "/api/homepage-data",

                    })
                    .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        return {};
                    } else {
                        this.homepage_statistics = this.$store.getters.getResults.data;
                    }
                });
            },
            getAboutUsData(){
                 return this.$store.dispatch(POST_API, {
                    data:{
                        token: this.email,
                    },
                    api:'/api/about-us-data'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;

                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: this.error_message,
                            showConfirmButton: false,
                            timer: 1500
                        });

                    } else {
                        this.about_us = this.$store.getters.getResults.about_us;
                    }
            })

            },
             getWebsiteData() {
      return this.$store.dispatch(POST_API, {
        data: { keyword: this.filter, },
            api: '/api/website-data'
      })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                return [];
            } else {
                this.video = this.$store.getters.getResults.video;
              }
        });
            }
        },
        mounted(){
            //document.title = "EL Connect - About Us";
            window.scrollTo(0, 0);
            Promise.all([
                this.about_us.length           ? Promise.resolve() : this.getAboutUsData(),
                this.video                     ? Promise.resolve() : this.getWebsiteData(),
                this.homepage_statistics.job_count ? Promise.resolve() : this.getHomepageData(),
            ]).finally(() => {
                document.dispatchEvent(new Event('x-app-rendered'));
            });
        },
    }
</script>
